export default "__VITE_ASSET__BGH_$oB0__"